import React from 'react';
import {TableProps} from './TableTypes';
import {DropdownButton, DropdownItem} from '../Dropdown';
import {IconButton} from '../Button';
import { SystemIcons} from '../icons';
import {COLORS} from '../styles';
import {
  StyledTableFooter, StyledTableFooterCollapseButton,
  StyledTableFooterContent,
  StyledTableFooterControls,
  StyledTableFooterCurrentInfo
} from './TableStyles';
import {defaultOnMouseDownHandler} from '../common';


interface TableFooterProps extends TableProps {
  onRowsPerPageChange: (value: number) => void;
  rowsPerPage: number;
  from?: number;
  to?: number;
  total?: number;
  nextPage: () => void;
  prevPage: () => void;
  setIsCollapsed: (isCollapsed: boolean) => void;
  isCollapsed: boolean;
}

const TableFooter: React.FunctionComponent<TableFooterProps> = (props) => {
  const rowsPerPageValues: DropdownItem[] = [{value: '10'}, {value: '20'}, {value: '50'}, {value: '100'}];

  const dropDownText = `${props.rowsPerPageLabel ?? 'Rows per page'} : ${props.rowsPerPage}`;

  return (
    <StyledTableFooter data-testid="TestTableFooterRow">
          {
            props.accordion &&
            <StyledTableFooterCollapseButton onClick={() => props.setIsCollapsed(!props.isCollapsed)}
                                             onMouseDown={defaultOnMouseDownHandler}
                                             disabled={props.isCollapsed && props.rows.length <= props.rowsPerPage}>
              {
                props.isCollapsed &&
                <>
                  <span>{props.showMoreLabel ?? 'Show more'} ({props.rows.length - props.rowsPerPage})</span>
                  <SystemIcons.ArrowDropDown/>
                </>
              }
              {
                !props.isCollapsed &&
                <>
                  <span>{props.showFewerLabel ?? 'Show fewer'}</span>
                  <SystemIcons.ArrowDropUp/>
                </>
              }
            </StyledTableFooterCollapseButton>
          }
          {
            !props.accordion &&
            <StyledTableFooterContent>
              <DropdownButton
                type={'text'}
                items={rowsPerPageValues}
                disabled={props.showLoadingIndicator}
                value={[`${props.rowsPerPage}`]}
                onClick={(value) => props.onRowsPerPageChange(+value[0])}
                label={dropDownText}
                keepLabel={true}
              />
              <StyledTableFooterCurrentInfo>
                {props.total === 0 ? 0 : props.from}-{props.to} of {props.total}
              </StyledTableFooterCurrentInfo>
              <StyledTableFooterControls>
                <IconButton variant="secondary" shape="circular" action={() => props.prevPage()}
                            disabled={props.from === 1 || props.showLoadingIndicator}>
                  <SystemIcons.ChevronLeft size="24" color={COLORS.neutral_600}/>
                </IconButton>
                <IconButton variant="secondary" shape="circular" action={() => props.nextPage()}
                            disabled={props.to === props.total || props.showLoadingIndicator}>
                  <SystemIcons.ChevronRight size="24" color={COLORS.neutral_600}/>
                </IconButton>
              </StyledTableFooterControls>
            </StyledTableFooterContent>
          }
    </StyledTableFooter>
  );
};


export default TableFooter;
